import React from 'react'
import PropTypes from 'prop-types'
import { Content } from '@pcln/ace-content-react'
import { Heading, Text } from 'pcln-design-system'
import Modal from '../Modal'
import {
  HotelsTypeAheadForm,
  handleModalContainerOnClick,
  ModalContainer
} from '../../../NEW_SEARCH_SearchForms'
import { formatHotelsURL } from '../../../search-forms/utils/hotels-url-formatters'
import HotelsSearchContainer from '../../../../containers/hotels/HotelsSearchContainer'
import { validatePromoDeals } from '../../../../utils/validateHotels'
import { fireSearchClick } from '../../../../actions/GoogleAnalyticsClickActions'
import { ANALYTICS_CATEGORY, HotelSearchFormModalTypes } from '../../../../constants/Constants'
import CONTENT from '../../../../constants/Content'

const HTL_ED_MODAL_ID = 'htl-ed-modal'
const HOTEL_TAB_KEY = 'hotels'
const HOME_CONTENT = CONTENT.home

const handleSOPQSearchClick = data => {
  fireSearchClick(
    HOME_CONTENT.forms.hotels.ga.searchClickSOPQ,
    data,
    ANALYTICS_CATEGORY,
    'Feature Box Modal'
  )

  // This version of home-components search form results 'Invalid' string; MVP version of the form will update the GA code pattern
  if (data !== 'Invalid') {
    fireSearchClick(
      HOME_CONTENT.forms.hotels.ga.sopqSearchValidSubmission,
      HOME_CONTENT.forms.hotels.ga.searchValidSubmissionLabel
    )
  }
}

const handleExpressDealsSubmit = values => {
  const url = formatHotelsURL({
    ...values,
    dealType: 'EXPRESS_DEAL'
  })
  handleSOPQSearchClick(values)
  window.open(url)
}

const SOPQModal = props => {
  return (
    <ModalContainer
      onClick={e => {
        const opts = {
          props: props.clickProps,
          event: e,
          modalID: HTL_ED_MODAL_ID,
          tab: HOTEL_TAB_KEY
        }
        handleModalContainerOnClick(opts)
      }}
    >
      <Modal
        id={HTL_ED_MODAL_ID}
        show={props.show}
        onClose={e => {
          props.onPromoToggle()
          props.onClose()
        }}
        isUsingInnerRef
      >
        <Heading fontSize={'36px'} mb={2}>
          <Content
            name={['SITE-X.HOMEPAGE.SEARCHAREA.EXPRESSDEALS.TITLE']}
            fallback='Search For Express Deals'
          /> <sup>®</sup>
        </Heading>
        <Text mb={4}>
          Save up to 60% Fast and Easy - No Bidding Required!
        </Text>
        <HotelsSearchContainer
          {...props.initialValues}
          onSubmit={handleExpressDealsSubmit}
          validate={validatePromoDeals}
          render={props => (
            <HotelsTypeAheadForm
              {...props}
              typeAhead={{
                endpoint: 'hotels',
                keys: ['location']
              }}
              modalType={HotelSearchFormModalTypes.SOPQ}
            />
          )}
        />
      </Modal>
    </ModalContainer>
  )
}

SOPQModal.defaultProps = {
  bodyColor: '#596b7d',
  bodyFontSize: 3,
  clickProps: {},
  headingFontSize: 5,
  headingText: '',
  initialValues: {},
  onClose: () => {},
  onPromoToggle: () => {}
}

SOPQModal.propTypes = {
  bodyColor: PropTypes.string,
  clickProps: PropTypes.object,
  handleTypeaheadPromise: PropTypes.func,
  headingFontSize: PropTypes.number,
  initialValues: PropTypes.object,
  onClose: PropTypes.func,
  onPromoToggle: PropTypes.func,
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  sopqContent: PropTypes.object
}

export default SOPQModal
